module.exports = function() {
  return new Worker(__webpack_public_path__ + "594bb8035a8f08cd25f1.worker.js");
};